export default {
  hero: {
    badge: "Soluciones Digitales",
    titlePrefix: "Todo lo que tu Negocio Necesita",
    titleHighlight: "para Crecer Online",
    subtitle: "Desde sitios web personalizados y branding hasta automatización con IA y estrategia — construimos la infraestructura digital que convierte tu visión en resultados.",
    cta: {
      book: "Agendar una Consultoría Gratuita",
      team: "Conoce al Equipo"
    },
    stats: {
      services: "Servicios Ofrecidos",
      custom: "Soluciones Personalizadas",
      support: "Soporte y Hosting"
    }
  },
  detail: {
    common: {
      forWho: "Para quién es:",
      book: "Reservar una Consulta"
    },
    featured: {
      badge: "Servicio Destacado",
      mostPopular: "Más Popular",
      title: "Creación de Sitio Web + Hosting",
      desc: "Sitios web personalizados, modernos y de alta conversión diseñados para empresas y emprendedores. Incluye desarrollo completo, optimización móvil, estructura lista para SEO e integración de hosting.",
      benefits: {
        b1: "Diseño personalizado adaptado a tu marca",
        b2: "Optimizado para móviles y totalmente responsivo",
        b3: "Estructura lista para SEO desde el primer día",
        b4: "Rendimiento rápido y hosting incluido",
        b5: "Formularios de captura e integración de CTAs",
        b6: "Solución integral — sin dolores de cabeza técnicos"
      },
      forWho: "Dueños de negocios, emprendedores y marcas que desean una presencia en línea sólida, profesional y escalable."
    },
    header: {
      prefix: "Todos Nuestros",
      highlight: "Servicios",
      subtitle: "Todo lo que necesitas para construir, hacer crecer y escalar tu negocio en línea — bajo un mismo techo."
    },
    items: {
      crm: {
        title: "Creación de CRM",
        desc: "Sistemas CRM hechos a medida para gestionar leads, clientes, flujos de trabajo y operaciones internas de manera eficiente.",
        benefits: {
          b1: "Mejor organización y seguimiento de clientes",
          b2: "Automatización de procesos repetitivos",
          b3: "Aumento de la productividad del equipo",
          b4: "Datos e informes centralizados"
        },
        forWho: "Empresas que desean escalar sus operaciones."
      },
      branding: {
        title: "Branding y Diseño",
        desc: "Creación de identidad de marca, incluyendo logotipos, paletas de colores, dirección visual y materiales de marketing.",
        benefits: {
          b1: "Mayor reconocimiento de marca",
          b2: "Imagen profesional y consistente",
          b3: "Logo + kit de marca completo",
          b4: "Plantillas de material de marketing"
        },
        forWho: "Nuevos negocios que necesitan un refresh o una identidad más sólida."
      },
      consulting: {
        title: "Consultoría de Redes Sociales",
        desc: "Orientación estratégica para ayudar a las empresas a crecer y posicionarse de manera efectiva en las redes sociales.",
        benefits: {
          b1: "Estrategia y dirección de contenido claras",
          b2: "Hoja de ruta de crecimiento accionable",
          b3: "Información sobre segmentación de audiencia",
          b4: "Tácticas de engagement y conversión"
        },
        forWho: "Dueños que quieren gestionar su propio contenido con guía experta."
      },
      content: {
        title: "Consultoría de Creación de Contenido",
        desc: "Guía sobre cómo crear contenido atractivo y estratégico que atraiga y convierta a tu audiencia ideal.",
        benefits: {
          b1: "Mejores ideas y estructura de contenido",
          b2: "Mejora en la consistencia de publicación",
          b3: "Mayores tasas de interacción",
          b4: "Contenido que convierte seguidores"
        },
        forWho: "Creadores y empresas con dificultades en la estructura de su contenido."
      },
      optimization: {
        title: "Optimización de Redes Sociales",
        desc: "Optimización de perfiles en redes sociales para mejorar la claridad, el branding y el rendimiento de conversión.",
        benefits: {
          b1: "Perfiles más profesionales",
          b2: "Mejores primeras impresiones",
          b3: "Mejor estrategia de bio y enlaces",
          b4: "Mayor conversión de visitantes"
        },
        forWho: "Negocios con perfiles existentes que necesitan mejoras."
      },
      google: {
        title: "Perfil de Google Business",
        desc: "Configuración y optimización del Perfil de Empresa en Google para mejorar la visibilidad local y atraer más clientes.",
        benefits: {
          b1: "Mejor posicionamiento en SEO local",
          b2: "Mayor visibilidad en Google Maps",
          b3: "Más consultas de clientes",
          b4: "Ficha de negocio profesional"
        },
        forWho: "Negocios locales que quieren aparecer en búsquedas y mapas."
      },
      ai: {
        title: "Automatización con IA y Funnels",
        desc: "Creación de sistemas automatizados, funnels y flujos de trabajo utilizando IA y herramientas digitales que funcionan 24/7.",
        benefits: {
          b1: "Flujos de trabajo automatizados que ahorran tiempo",
          b2: "Mejores tasas de conversión de leads",
          b3: "Customer journeys automatizados",
          b4: "Sistemas de seguimiento impulsados por IA"
        },
        forWho: "Empresas que desean escalar con automatización y sistemas más inteligentes."
      },
      strategy: {
        title: "Consultoría y Estrategia",
        desc: "Sesiones de consultoría personalizadas enfocadas en el crecimiento empresarial, la estrategia digital y la planificación de la ejecución.",
        benefits: {
          b1: "Dirección clara y conocimientos expertos",
          b2: "Planes de crecimiento accionables",
          b3: "Auditoría digital y análisis de brechas",
          b4: "Responsabilidad y seguimiento"
        },
        forWho: "Emprendedores listos para crecer y escalar."
      }
    },
    footerCta: {
      title: "¿No estás seguro de qué servicio es el adecuado para ti?",
      subtitle: "Agenda una llamada estratégica gratuita y te ayudaremos a determinar exactamente lo que tu negocio necesita para crecer.",
      book: "Obtener una Consultoría Gratuita"
    }
  }
};
